import * as React from "react";
import styled from "styled-components";

const ContentWrapper = styled.div`
    max-width: 800px;
    margin-left: auto;
    margin-right: auto;
    padding-left: 20px;
    padding-right: 20px;
`;

export default ContentWrapper;
